const isDefaultBrand = (theme) => {
  return (
    theme.brand === "default" ||
    (theme.brand !== "default" && theme.palette.brand === undefined)
  );
};

export default isDefaultBrand;
